<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/andon/record/listByPage" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_cross_select multiple :component="'web_base_equipment_list'" :ids.sync="yt.conditions.equipments"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('yijiandengleixingmingcheng')">
            <el-select multiple filterable :clearable="true" v-model="yt.conditions.exceptionTypes">
              <el-option v-for="(item, index) in exceptionTypeList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
            <!-- <yi_data_select type="exception_type" :ids.sync="yt.conditions.exceptionTypes"></yi_data_select> -->
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc,triggerTime asc', status: 1 })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('jiechuandeng', scope.row, 'w1')" v-if="utils.checkPower('web_andon_management_remove_exception_relieve')">
              {{ $t('jiechuandeng') }}
            </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 确认异常 -->
      <template v-if="yt.editObj.action == 'jiechuandeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <!-- <el-form-item :label="$t('erjiandengleixingmingcheng')" required>
            <el-select filterable :clearable="true" v-model="yt.editObj.levelSecondExceptionTypeId">
              <el-option v-for="(item, index) in pageSecondLevelList" :key="index" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item :label="$t('jiejuecuoshi')" required>
            <el-input v-model="yt.editObj.solution"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/andon/record/relieve')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_andon_management_remove_exception_list',
  components: {},
  data() {
    return {
      exceptionTypeList: [],
      pageSecondLevelList: [],
      productionUnitList: [],
      columns: [
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'yijiandengleixingmingcheng',
          prop: 'exceptionType.name',
          width: 130
        },
        {
          label: 'erjiandengleixingmingcheng',
          prop: 'levelSecondExceptionType.name',
          width: 180
        },
        {
          label: 'chufashijian',
          prop: 'triggerTime',
          type: 'time'
        },
        {
          label: 'querenshijian',
          prop: 'confirmTime',
          type: 'time'
        },
        {
          label: 'chufaren',
          prop: 'triggerUser.nickname'
        },
        {
          label: 'andengmiaoshu',
          prop: 'description'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 130,
          fixed: 'right'
        }
      ]
    };
  },
  watch: {
    'yt.editObj.action': {
      handler(n, o) {
        if (n) {
          this.getPageSecondLevel();
        }
      },
      immediate: false,
      deep: true
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc,triggerTime asc',
        status: 1
      };
      this.yt.get(1);
    }, 300);
  },
  mounted() {
    this.getExceptionType();
  },
  methods: {
    //一级异常类型
    getExceptionType() {
      this.http
        .get('/web/andon/exceptionType/page', {
          params: {
            parentId: this.yt.editObj.exceptionTypeId,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.exceptionTypeList = res.data.rows;
        });
    },
    //二级异常类型
    getPageSecondLevel() {
      this.http
        .get('/web/andon/exceptionType/pageSecondLevel', {
          params: {
            parentId: this.yt.editObj.exceptionTypeId,
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(res => {
          this.pageSecondLevelList = res.data.rows;
        });
    }
  }
};
</script>
